/**
 * Formats a raw ATS application stage value for display.
 * Handles snake_case, UPPER_CASE, kebab-case → Title Case.
 */
export function formatApplicationStage(stage: string): string {
  return stage
    .replace(/[_-]/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase())
}
